<div id="mySidepanel" class="sidepanel">
    <div class="form">
        <div fxLayout="column wrap">
            <div class="headContent">
                <span class="head">{{panelTitle}}</span>
                <i id="closeX" (click)="closeDD()" class="flaticon-close"></i>
            </div>
            <logzy-branch-contact *ngIf="panelTitle=='Customer Directory'" [isEditable]="editBranchContact"
                [customerDirectoryObj]="refreshCustomerDirectoryObj" (closeForm)="closeForm($event)"
                [selectedCustomerDirectory]="selectedBranchContact" [forceRefreshBranchUrls]="forceRefreshBranchUrls"
                [companyId]="customerObj?.id"></logzy-branch-contact>
            <logzy-branch-internal-contact *ngIf="panelTitle=='Customer Engagement'"
                [isEditable]="editBranchInternalContact" [customerEngagementObj]="refreshCustomerEngagementObj"
                (closeForm)="closeForm($event)" [companyId]="customerObj?.id"
                [selectedCustomerEngagement]="selectedBranchInternalContact"></logzy-branch-internal-contact>
            <logzy-kyc-document-form *ngIf="panelTitle=='KYC Details'"
                [refreshTaxIdentifiers]="forceRefreshTaxIdentifiers"
                (closeForm)="closeForm($event)"></logzy-kyc-document-form>
            <logzy-bank-details-form *ngIf="panelTitle=='Bank Details'" [bankObj]="refreshBankObj"
                [selectedBank]="selectedBank" (closeForm)="closeForm($event)"
                [companyId]="customerObj?.id"></logzy-bank-details-form>
        </div>
    </div>
</div>
<button class="edit" color="primary" mat-fab (click)="editableToggle()" *ngIf="customerObj.id && customerObj.is_active" cdkDrag>
    <i MatSuffix id="i1" class="flaticon-{{isEditable? 'close': 'pencil-tool'}}"></i>
</button>

<cdk-customer-stepper class="relaxed" id="customStepper2" #errorInStep>
    <cdk-step>
        <div id="top"></div>
        <ng-template cdkStepLabel>Basic Details</ng-template>
        <div class="proBg">
            <mat-progress-bar id="progressBar" class="progressSlider" mode="determinate" value="{{counter}}">
            </mat-progress-bar>
        </div>
        <div class="form formLayout ">
            <logzy-content-loader *ngIf="Loader" [set1]="Loader"></logzy-content-loader>
            <logzy-content-loader *ngIf="Loader" [set2]="Loader"></logzy-content-loader>
            <logzy-content-loader *ngIf="Loader" [set2]="Loader"></logzy-content-loader>
            <div class="content form-group" id="card1" fxLayout="column wrap" *ngIf="!Loader">
                <div class="headContent diplayStat">
                    <button mat-icon-button (click)="backToList()" class="backArrow">
                        <i class="flaticon-back-arrow"></i>
                    </button>
                    <span class="head"> Introductory Details</span>
                    <div *ngIf="customerObj.id" class="stat">
                        <!-- <span> KYC Status</span> -->
                        <mat-chip [class.reject]="customerObj.kyc_status?.dev_name=='rejected'"
                            [class.approved]="customerObj.kyc_status?.dev_name=='approved' || customerObj.kyc_status?.dev_name=='auto_approved'">
                            {{customerObj.kyc_status?.name_kyc}}
                        </mat-chip>
                    </div>
                </div>
                <div fxFlex="100" class="inputs inputMaxWidth" fxLayout="row wrap">
                    <div fxFlex="100" fxLayout="row wrap">
                        <div class="inputTitle" fxFlex="100">
                            <span>Country*</span>
                        </div>
                        <app-mat-auto-search [isEditable]="isEditable && isCountryEditable" [name]="'country'"
                            [ngModel]="customerObj.country" [idField]="null"
                            (ngModelChange)="getFieldsOnCountryChange($event)" [setSearchValue]="false"
                            [displayField]="'name'" [listUrl]="country_url" fxFlex="100" fxFlex.gt-xs="13.8em"
                            fxLayout="column" [errors]="errorObj?.country">
                        </app-mat-auto-search>
                        <div style="display:flex">
                            <mat-checkbox color="primary" [ngModel]="customerObj.is_b2c"
                                (ngModelChange)="onB2CChange($event)" style="margin-bottom: 1em;" [name]="'is_b2c'"
                                [disabled]="!isEditable || (customerObj.kyc_status?.dev_name=='approved' || customerObj.kyc_status?.dev_name=='auto_approved')">
                                Is B2C?
                            </mat-checkbox>
                            <mat-checkbox color="primary" [(ngModel)]="customerObj.is_active" style="margin-bottom: 1em;" [name]="'is_b2c'"
                                [disabled]="!isEditable || isEditable">
                                Is Active
                            </mat-checkbox>
                        </div>
                    </div>
                    <ng-container *ngIf="customerObj.country!=null && isCountryEditable">
                        <div *ngIf="taxIdentifierList?.results?.length" fxFlex="100" class="taxIdentifier"
                            fxLayout="row wrap">
                            <ng-container *ngFor="let item of taxIdentifierList?.results, let i=index">
                                <div *ngIf="item?.is_hidden==false && item?.show_id_value_field==true" fxFlex="100"
                                    class="position-relative" fxFlex.gt-xs="13.8em" fxLayout="column">
                                    <div class="inputTitle">
                                        <span>{{item?.name}}{{item?.is_identifier_required ? '*' : ''}}</span>
                                    </div>
                                    <app-text-field [isEditable]="isEditable" [name]="'taxIdentifier'+i"
                                        [(ngModel)]="customerObj.tax_identifiers[i].id_value"
                                        [disabled]="item?.is_disabled" (focusOut)="getCompanyDetailsByGST(item,i)">
                                    </app-text-field>
                                    <div class="errorManual" *ngIf="errorObj?.tax_identifiers?.length">
                                        <li *ngFor="let error of errorObj?.tax_identifiers[i]?.id_value">{{error}}</li>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="customerObj.id && !isCountryEditable">
                        <div fxFlex="100" class="taxIdentifier" fxLayout="row wrap">
                            <ng-container *ngFor="let item of customerObj.tax_identifiers, let i=index">
                                <div *ngIf="item?.tax_identifier?.is_hidden==false && item?.tax_identifier?.show_id_value_field==true"
                                    fxFlex="100" class="position-relative" fxFlex.gt-xs="13.8em" fxLayout="column">
                                    <div class="inputTitle">
                                        <span>{{item?.tax_identifier?.name}}{{item?.tax_identifier?.is_identifier_required
                                            ? '*' : ''}}</span>
                                    </div>
                                    <app-text-field
                                        [isEditable]="isEditable && !(customerObj.kyc_status?.dev_name=='approved' || customerObj.kyc_status?.dev_name=='auto_approved')"
                                        [name]="'taxIdentifier'" [(ngModel)]="customerObj.tax_identifiers[i].id_value"
                                        [nestedError]="errorObj?.tax_identifiers?.length ? errorObj.tax_identifiers[i]?.id_value?.length:false"
                                        [disabled]="item?.tax_identifier?.is_disabled"
                                        (focusOut)="getCompanyDetailsByGST(item?.tax_identifier,i)">
                                    </app-text-field>
                                    <div class="errorManual" *ngIf="errorObj?.tax_identifiers?.length">
                                        <li *ngFor="let error of errorObj.tax_identifiers[i]?.id_value">{{error}}</li>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Legal Name of Company*</span>
                        </div>
                        <app-text-field [isEditable]="isEditable" [name]="'legal_name'"
                            [(ngModel)]="customerObj.legal_name" (focusOut)="onLegalNameChange()"
                            [errors]="errorObj.legal_name"></app-text-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Trade Name of Company*</span>
                        </div>
                        <app-text-field [isEditable]="isEditable" [name]="'trade_name'"
                            [(ngModel)]="customerObj.trade_name" [errors]="errorObj.trade_name">
                        </app-text-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Parent Company Name*</span>
                        </div>
                        <app-mat-auto-search [isEditable]="isEditable" [name]="'parent_company_name'"
                            [(ngModel)]="customerObj.group" (change)="getCompanyGroup($event)"
                            [listUrl]="companyGroup_url" [displayField]="'name'" [idField]="null"
                            [setSearchValue]="true" [errors]="errorObj.group?.id">
                        </app-mat-auto-search>
                        <!-- <div *ngIf="errorObj?.group">
                            <li *ngFor="let item of errorObj.group.id">{{item}}</li>
                        </div> -->
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Type of customer</span>
                        </div>
						<app-mat-auto-search [(ngModel)]="customerObj.company_type" [isEditable]="isEditable"
                            [idField]="null" [displayField]="'name'" [name]="'company_type'"
                            [listUrl]="companyType_url" [searchable]="true" [searchIcon]="true"
                            [errors]="errorObj.company_type">
                        </app-mat-auto-search>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Industry Type</span>
                        </div>
                        <app-select-field [(ngModel)]="customerObj.industry_type" [isEditable]="isEditable"
                            [idField]="null" [displayField]="'value'" [name]="'industry_type'"
                            [options]="industryTypeList?.results" [searchable]="true" [trim]="true"
                            [errors]="errorObj.industry_type">
                        </app-select-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Incorporation Type</span>
                        </div>
                        <app-mat-auto-search [(ngModel)]="customerObj.constitution" [isEditable]="isEditable"
                            [idField]="null" [displayField]="'name'" [name]="'constitution'"
                            [listUrl]="incorporation_type_url" [searchable]="true" [searchIcon]="true"
                            [errors]="errorObj.constitution">
                        </app-mat-auto-search>
                    </div>
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class=" inputTitle sToggle">
                            <mat-slide-toggle color="primary" [(ngModel)]="customerObj.is_sez"
                                [disabled]="customerObj.id || customerObj?.country?.code=='IN'">
                                Special Rebates ?<i MatSuffix
                                    matTooltip="Special Rebates applicable as per tax rules ( E.g. SEZ unit)"
                                    matTooltipPosition="below" matTooltipHideDelay="2000" id="i1"
                                    class="flaticon-message"></i>
                            </mat-slide-toggle>
                        </div>
                    </div>
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Preferred Currency*</span>
                        </div>
                        <app-mat-auto-search [isEditable]="isEditable" [name]="'currency_code'"
                            [(ngModel)]="customerObj.default_currency" [listUrl]="currencyUrl" [idField]="'currency_code'"
                            [displayField]="'currency_code'" [setSearchValue]="true" [errors]="errorObj.default_currency">
                        </app-mat-auto-search>
                        <!-- <div *ngIf="errorObj?.group">
                            <li *ngFor="let item of errorObj.group.id">{{item}}</li>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="content form-group" id="card2" fxLayout="column wrap" *ngIf="!Loader">
                <div class="headContent flexSpaceBtwn" fxFlex="100" fxLayout="row wrap">
                    <span class="head">
                        Branch Address
                    </span>
                </div>
                <div fxFlex="100" class="inputs rg1em" fxLayout="row wrap">
                    <ng-container *ngIf="customerObj?.primary_branch">
                        <div class="georgraphyCard">
                            <div>
                                <input disabled type="text" name="unit_name" value="Main Branch">
                                <button mat-icon-button [disabled]="!isEditable" class="Save">
                                    <i class="flaticon-pencil" [class.noPointer]="!isEditable"
                                        [class.highlight]="isEditable" (click)="patchPrimaryAddress()"></i>
                                </button>
                            </div>
                            <p>
                                <textarea disabled name="full_address"
                                    value="{{customerObj.primary_branch?.address}}"></textarea>
                            </p>
                            <p>Pincode:
                                <input disabled value="{{customerObj.primary_branch?.pincode}}" type="text"
                                    name="pincode">
                            </p>
                            <div class="ikm">
                                <input disabled value="{{customerObj.primary_branch?.city?.name}}" type="text"
                                    name="city">
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="customerObj?.secondary_branches?.length">
                        <div class="georgraphyCard" *ngFor="let item of customerObj.secondary_branches; let i=index">
                            <div>
                                <input disabled type="text" name="unit_name" class="geoTitle"
                                    value="{{item?.unit_name?.dev_value=='main_branch' ? 'Main Branch' : 'Secondary Branch'}}">
                                <button mat-icon-button [disabled]="!isEditable" class="Save">
                                    <i class="flaticon-pencil" (click)="patchSecondaryAddress(item,i)"
                                        [class.noPointer]="!isEditable"></i>
                                </button>
                            </div>
                            <p>
                                <textarea disabled name="full_address" value="{{item?.address}}"></textarea>
                            </p>
                            <p>Pincode:
                                <input disabled value="{{item?.pincode}}" type="text" name="pincode">
                            </p>
                            <div class="ikm">
                                <input disabled value="{{item?.city?.name}}" type="text" name="city">
                            </div>
                        </div>
                    </ng-container>
                </div>
                <mat-divider
                    *ngIf="(customerObj?.primary_branch != null || customerObj?.secondary_branches?.length) && isEditable"></mat-divider>
                <div fxFlex="100" id="branch_details" class="inputs inputMaxWidth" fxLayout="row wrap"
                    *ngIf="isEditable">
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>State*</span>
                        </div>
                        <app-mat-auto-search [isEditable]="isEditable" [(ngModel)]="state" [name]="'state'"
                            [idField]="null" [displayField]="'name'" (ngModelChange)="filterCityByStateID($event)"
                            [listUrl]="state_url" [errors]="errorObj.state">
                        </app-mat-auto-search>
                    </div>
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>City</span>
                        </div>
                        <app-mat-auto-search [isEditable]="isEditable" [(ngModel)]="city" [name]="'city'"
                            [idField]="null" [displayField]="'name'" [listUrl]="city_url" [errors]="errorObj.city">
                        </app-mat-auto-search>
                    </div>
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Pincode</span>
                        </div>
                        <app-number-field [isEditable]="isEditable" [name]="'pincode'" [(ngModel)]="pincode"
                            [maxlength]="8" [noDecimal]="true" [errors]="errorObj.pincode">
                        </app-number-field>
                    </div>
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Address*</span>
                        </div>
                        <app-text-field [isEditable]="isEditable" [name]="'address'" [isMultiline]="true"
                            [(ngModel)]="address" [errors]="errorObj.address">
                        </app-text-field>
                    </div>
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Unit Name*</span>
                        </div>
                        <!-- <mat-chip>Main Branch</mat-chip> -->
                        <app-select-field [(ngModel)]="branchUnitName" [isEditable]="isEditable" [idField]="null"
                            [displayField]="'value'" [name]="'unit_name'" [options]="branchUnitTypeList?.results"
                            [searchable]="true" [trim]="true" [errors]="errorObj.unit_name">
                        </app-select-field>
                    </div>
                    <div fxFlex="100" fxLayout="column" class="branchAction">
                        <button mat-raised-button *ngIf="isNewAddress" (click)="addCompanyAddresses()"
                            [disabled]="!isEditable">Add Branch
                        </button>
                        <button mat-raised-button *ngIf="isUpdateAddress" (click)="updateAddress()"
                            [disabled]="!isEditable">Update Branch
                        </button>
                    </div>
                </div>


            </div>
            <div class="content form-group" id="card3" fxLayout="column wrap" *ngIf="!Loader">
                <div class="headContent">
                    <span class="head"> Company Contact Details</span>
                </div>
                <div fxFlex="100" class="inputs inputMaxWidth" fxLayout="row wrap">
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Primary Contact No</span>
                        </div>
                        <app-text-field [isEditable]="isEditable" [(ngModel)]="customerObj.primary_contact_no"
                            [name]="'primary_contact_no'" [errors]="errorObj.primary_contact_no">
                        </app-text-field>
                    </div>
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Secondary Contact No</span>
                        </div>
                        <app-text-field [isEditable]="isEditable" [(ngModel)]="customerObj.secondary_contact_no"
                            [name]="'secondary_contact_no'" [errors]="errorObj.secondary_contact_no">
                        </app-text-field>
                    </div>
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Primary Email Address</span>
                        </div>
                        <app-text-field [isEditable]="isEditable" [name]="'primary_email'"
                            [(ngModel)]="customerObj.primary_email" [errors]="errorObj.primary_email">
                        </app-text-field>
                    </div>
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Secondary Email Address</span>
                        </div>
                        <app-text-field [isEditable]="isEditable" [name]="'secondary_email'"
                            [(ngModel)]="customerObj.secondary_email" [errors]="errorObj.secondary_email">
                        </app-text-field>
                    </div>
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span> Logo of company</span>
                        </div>
                        <app-file-field [isEditable]="isEditable" [fileDropArea]="false" [showUploadedList]="false"
                            [(ngModel)]="customerObj.logo" [documentTypeDevName]="'profile_picture'" [name]="'logo'"
                            [label]="'Upload Logo'" [isSolidUploadIcon]="true" [multiple]="false"
                            [errors]="errorObj.document"></app-file-field>
                        <span class="selectedCompanyLogo"
                            *ngIf="customerObj.logo?.original_filename && isEditable">Selected:
                            <b>{{customerObj.logo?.original_filename}}.{{customerObj.logo?.extension}}</b></span>
                        <div *ngIf="!isEditable" class="customerLogo">
                            <img [src]="customerObj.logo?.document_file" alt="logo">
                            <div fxLayout="column" class="align-items-flex-start">
                                <span>{{customerObj.logo?.original_filename}}.{{customerObj.logo?.extension}}</span>
                                <span>{{customerObj.logo?.created_at|date:"dd MMM, yyyy"}}</span>
                                <span>{{embassyService.readableFileSize(customerObj.logo?.size)}}</span>
                            </div>

                        </div>
                    </div>
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                        <div class="inputTitle">
                            <span>Website</span>
                        </div>
                        <app-text-field [isEditable]="isEditable" [name]="'website'" [(ngModel)]="customerObj.website"
                            [errors]="errorObj.website">
                        </app-text-field>
                    </div>
                    <div class="btnb-fp" fxFlex="100">
                        <button class="bck" mat-stroked-button (click)="backToList()">Back</button>
                        <button mat-stroked-button cdkStepperNext class="nxt"
                            (click)="isEditable ? saveCustomer() : ''">{{isEditable ? 'Save Records' : 'Next'}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </cdk-step>
    <cdk-step>
        <div id="top"></div>
        <ng-template cdkStepLabel>Customer Communication</ng-template>
        <div class="proBg">
            <mat-progress-bar id="progressBar1" class="progressSlider" mode="determinate" value="{{counter1}}">
            </mat-progress-bar>
        </div>
        <div class="form1 formLayout" action="" fxLayout="column wrap">

            <logzy-content-loader *ngIf="Loader" [set2]="Loader"></logzy-content-loader>
            <logzy-content-loader *ngIf="Loader" [set2]="Loader"></logzy-content-loader>
            <div class="content form-group" id="card4" fxLayout="column wrap" *ngIf="!Loader">
                <div class="headContent justify-content-between" fxFlex="100" fxLayout="row">
                    <span class="head">
                        Customer Directory<i MatSuffix matTooltip="Customer end contact details."
                            matTooltipPosition="right" matTooltipHideDelay="2000" id="i1" class="flaticon-message"></i>
                    </span>
                    <button mat-raised-button (click)="openDD('Customer Directory',null,true)" class="sleekBtn "
                        [class.Save]="isEditable" [disabled]="!isEditable">Add Contact
                    </button>
                </div>
                <div fxFlex="100" class="inputs" fxLayout="row wrap">
                    <div fxFlex="100" class="contactTable setTable">
                        <mat-table [dataSource]="customerDirectoryList?.results" matSort>
                            <!-- Name Column -->
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Name</mat-header-cell>
                                <mat-cell *matCellDef="let contact">
                                    <span class="fullName">{{contact.first_name}} {{contact.last_name}}</span>
                                </mat-cell>
                            </ng-container>

                            <!-- Email Column-->
                            <ng-container matColumnDef="email">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Email</mat-header-cell>
                                <mat-cell *matCellDef="let contact"> {{contact.email}}</mat-cell>
                            </ng-container>

                            <!-- Profile/Designation Column -->
                            <ng-container matColumnDef="profile">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Designation</mat-header-cell>
                                <mat-cell *matCellDef="let contact"> {{contact.profile ?? '-'}}</mat-cell>
                            </ng-container>

                            <!-- Phone Column -->
                            <ng-container matColumnDef="phone">
                                <mat-header-cell *matHeaderCellDef> Mobile No.</mat-header-cell>
                                <mat-cell *matCellDef="let contact">{{contact.phone?.as_e164 ?? '-'}}</mat-cell>
                            </ng-container>

                            <!-- Actions Column -->
                            <ng-container matColumnDef="action">
                                <mat-header-cell *matHeaderCellDef> Action</mat-header-cell>
                                <mat-cell *matCellDef="let contact">
                                    <button mat-icon-button [matMenuTriggerFor]="menu"
                                        aria-label="Example icon-button with a menu" [disabled]="!isEditable">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item (click)="openDD('Customer Directory',contact,false)">
                                            <span>View Details</span>
                                        </button>
                                        <button mat-menu-item (click)="openDD('Customer Directory',contact,true)">
                                            <span>Edit Details</span>
                                        </button>

                                    </mat-menu>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                            <mat-row *matRowDef="let user; columns: displayedColumns"></mat-row>
                        </mat-table>
                    </div>
                    <div *ngIf="!customerDirectoryList?.results?.length" fxFlex="100" class="noTableData">
                        <span>Currently no contact exists in Customer Directory.</span>
                    </div>
                    <!-- <div *ngFor="let item of customerDirectoryList?.results" fxFlex="100" class="card" fxFlex.gt-md="40"
                        fxLayout="column">
                        <div class="fxapart" fxFlex="100">
                            <div class="profile">
                                <span>{{item?.first_name[0]}}{{item?.last_name[0]}}</span>
                            </div>
                            <div class="inputTitle">
                                <span>{{item?.first_name}} {{item?.last_name}}</span>
                                <br>
                                <span class="f12">{{item?.profile}} ({{item?.function}})</span><br>
                                <span class="f12">Mobile Number: {{item?.phone}}</span><br>
                                <span class="f12">{{item?.email}}</span>
                            </div>
                        </div>
                        <div class="btnb-fp" fxFlex="100">
                            <button class="bck" mat-stroked-button
                                (click)="openDD('Customer Directory',item,null)">Edit</button>
                            <button mat-stroked-button class="nxt">Emailers</button>
                        </div>
                    </div>
                    <div fxFlex="100" class="add-card" fxFlex.gt-md="40" fxLayout="column"
                        (click)="openDD('Customer Directory',null,null)">
                        <img src="assets/images/icons/new.svg" alt="">
                        <span>Create a new contact</span>
                    </div> -->
                </div>
            </div>
            <div class="content form-group" id="card5" fxLayout="column wrap" *ngIf="!Loader">
                <div class="headContent justify-content-between" fxFlex="100" fxLayout="row">
                    <span class="head">
                        Customer Engagement<i MatSuffix matTooltip="Internal User assign to communicate with customer."
                            matTooltipPosition="right" matTooltipHideDelay="3000" id="i1" class="flaticon-message"></i>
                    </span>
                    <button mat-raised-button (click)="openDD('Customer Engagement',null,true)" class="sleekBtn"
                        [class.Save]="isEditable" [disabled]="!isEditable">Add Contact
                    </button>
                </div>
                <div fxFlex="100" class="inputs" fxLayout="row wrap">
                    <div class="contactTable setTable" fxFlex="100">
                        <mat-table [dataSource]="customerEngagementList?.results" matSort>
                            <!-- Name Column -->
                            <ng-container matColumnDef="name">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Name</mat-header-cell>
                                <mat-cell *matCellDef="let contact">
                                    <!-- <img src="{{contact.picture==null?
                                        contact.gender=='Male'?base_url+'/media/profile_pics/man.svg':
                                        contact.gender=='Female'?base_url+'/media/profile_pics/woman.svg':
                                        base_url+'/media/profile_pics/default_dp.svg':contact.picture?.document_file}}" alt=""> -->
                                    <span class="fullName">{{contact.first_name}} {{contact.last_name}}</span>
                                </mat-cell>
                            </ng-container>

                            <!-- Email Column -->
                            <ng-container matColumnDef="email">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Email</mat-header-cell>
                                <mat-cell *matCellDef="let contact"> {{contact.email}}</mat-cell>
                            </ng-container>

                            <!-- Profile/Designation Column -->
                            <ng-container matColumnDef="function">
                                <mat-header-cell *matHeaderCellDef mat-sort-header> Function</mat-header-cell>
                                <mat-cell *matCellDef="let contact"> {{contact.function ?? '-'}}</mat-cell>
                            </ng-container>

                            <!-- Phone Column -->
                            <ng-container matColumnDef="phone">
                                <mat-header-cell *matHeaderCellDef> Mobile No.</mat-header-cell>
                                <mat-cell *matCellDef="let contact">{{contact.phone?.as_e164 ?? '-'}}</mat-cell>
                            </ng-container>

                            <!-- Action Column -->
                            <ng-container matColumnDef="action">
                                <mat-header-cell *matHeaderCellDef> Action</mat-header-cell>
                                <mat-cell *matCellDef="let contact">
                                    <button mat-icon-button [matMenuTriggerFor]="menu"
                                        aria-label="Example icon-button with a menu" [disabled]="!isEditable">
                                        <mat-icon>more_vert</mat-icon>
                                    </button>
                                    <mat-menu #menu="matMenu">
                                        <button mat-menu-item (click)="openDD('Customer Engagement',contact,false)">
                                            <span>View Details</span>
                                        </button>
                                        <button mat-menu-item (click)="openDD('Customer Engagement',contact,true)">
                                            <span>Edit Details</span>
                                        </button>
                                    </mat-menu>
                                </mat-cell>
                            </ng-container>
                            <mat-header-row *matHeaderRowDef="displayedColumns1"></mat-header-row>
                            <mat-row *matRowDef="let user; columns: displayedColumns1"></mat-row>
                        </mat-table>
                    </div>

                    <div *ngIf="!customerEngagementList?.results?.length" fxFlex="100" class="noTableData">
                        <span>Currently no contact exists in Customer Engagement.</span>
                    </div>
                </div>
                <div class="btnb" fxFlex="100" fxLayout="row">
                    <button class="bck" mat-stroked-button cdkStepperPrevious>Back</button>
                    <button mat-stroked-button cdkStepperNext class="nxt" (click)="scrolltop()">Next</button>
                </div>
            </div>
            <!-- <ng-container *ngIf="showBulk">
                <div class="content form-group" id="card4" fxLayout="column wrap">
                    <div class="headContent">
                        <span class="head"><b> Upload Data</b> </span>
                    </div>
                    <bulk-data></bulk-data>
                    <div class="btnb1" fxFlex="100">
                        <button class="bck" mat-raised-button cdkStepperPrevious class="bck">Back</button>
                        <button class="nxt" mat-stroked-button cdkStepperNext (click)="saveUpload()">Save
                            Upload</button>
                    </div>
                </div>
            </ng-container> -->
        </div>
    </cdk-step>
    <cdk-step>
        <div id="top"></div>
        <ng-template cdkStepLabel>KYC and Credit Details</ng-template>
        <div class="proBg">
            <mat-progress-bar id="progressBar2" class="progressSlider" mode="determinate" value="{{counter2}}">
            </mat-progress-bar>
        </div>
        <div action="" class="form formLayout" fxLayout="column wrap">
            <logzy-content-loader *ngIf="Loader" [set2]="Loader"></logzy-content-loader>
            <logzy-content-loader *ngIf="Loader" [set2]="Loader"></logzy-content-loader>
            <logzy-content-loader *ngIf="Loader" [set2]="Loader"></logzy-content-loader>
            <logzy-content-loader *ngIf="Loader" [set2]="Loader"></logzy-content-loader>
            <div class="content form-group" id="card5" fxLayout="column wrap" *ngIf="!Loader">
                <div class="headContent justify-content-between" fxFlex="100" fxLayout="row">
                    <span class="head">
                        KYC details
                    </span>
                    <button *ngIf="customerObj?.id && customerObj.is_active" mat-raised-button class="sleekBtn"
                        [class.Save]="(customerObj?.id && isEditable)" (click)="redirectToKycPage()">
                        Take Action
                    </button>
                </div>
                <div *ngIf="customerObj?.id" fxFlex="100" class="inputs" fxLayout="column wrap">
                    <div class="kyc" fxFlex="100" fxLayout="row wrap">
                        <div class="docCard" *ngFor="let docs of customerObj?.tax_identifiers; let idx=index"
                            fxFlex="12.8em" fxLayout="column">
                            <div class="justify-content-between w-100" fxFlex="100" fxLayout="row wrap">
                                <div>{{docs?.tax_identifier?.name}}</div>
                                <div>
                                    <span class="docStatus" [class.uploaded-doc-status]="docs?.document!=null">
                                        {{docs?.status?.name}}
                                    </span>
                                </div>
                            </div>
                            <div class="uploadIcon" fxFlex="100">
                                <div [matTooltip]="docs?.document?.original_filename" matTooltipPosition="below">
                                    <i *ngIf="!docs?.document?.extension" class="flaticon-file"></i>
                                    <ng-container [ngSwitch]="docs?.document?.extension">
                                        <img src="assets/images/icons/file-type/pdf.svg" *ngSwitchCase="'pdf'">
                                        <img src="assets/images/icons/file-type/jpg.svg" *ngSwitchCase="'jpg'">
                                        <img src="assets/images/icons/file-type/png.svg" *ngSwitchCase="'png'">
                                        <img src="assets/images/icons/file-type/docx.svg" *ngSwitchCase="'docx'">
                                        <img src="assets/images/icons/file-type/gif.svg" *ngSwitchCase="'gif'">
                                    </ng-container>
                                </div>

                            </div>
                            <div class="verifyNum" fxFlex="100" fxLayout="row wrap">
                                <span class="docNumber" *ngIf="docs?.id_value">
                                    {{docs?.id_value}}
                                </span>
                                <span class="noDocNumber" *ngIf="!docs?.id_value">
                                    {{docs?.tax_identifier?.name}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="kycTaxIdentifierList?.length" class="kycList" fxFlex="100" fxLayout="column wrap">
                        <span> <logzy-img-loader [src]="'/assets/images/icons/warning.svg'">
                            </logzy-img-loader> Document(s) pending for upload.</span>
                        <div>
                            <ng-container *ngFor="let item of kycTaxIdentifierList">
                                <mat-chip>{{item?.name}}{{item?.is_identifier_required ? '*' : ''}}</mat-chip>
                            </ng-container>
                        </div>

                    </div>
                </div>
            </div>
            <div class="content form-group" id="card5" fxLayout="column wrap" *ngIf="!Loader">
                <div class="headContent" fxFlex="100">
                    <span class="head">
                        Credit details
                    </span>
                </div>
                <div fxFlex="100" class="inputs" fxLayout="row wrap">
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column" class="align-items-flex-start">
                        <div class="inputTitle">
                            <span>Maximum TEU Credit</span>
                        </div>
                        <app-number-field [isEditable]="isEditable" [(ngModel)]="customerObj.max_teu_allocation"
                            [name]="'max_teu_allocation'" [minValue]="0" [maxlength]="5" [noDecimal]="true"
                            [errors]="errorObj.max_teu_allocation">
                        </app-number-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column" class="align-items-flex-start">
                        <div class="inputTitle">
                            <span>Credit Days</span>
                        </div>
                        <app-number-field [isEditable]="isEditable" [(ngModel)]="customerObj.credit_days"
                            [name]="'credit_days'" [minValue]="0" [maxlength]="3" [noDecimal]="true" [maxValue]="365"
                            [errors]="errorObj.credit_days">
                        </app-number-field>
                    </div>
                    <!-- <div fxFlex="100" fxFlex.gt-md="36.6em" fxLayout="row wrap"> -->
                    <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column" class="align-items-flex-start">
                        <div class="inputTitle creditValue">
                            <span>Credit Limits</span>
                        </div>
                        <logzy-money-field [isEditable]="isEditable" [name]="'credit_limits'"
                            [(amount)]="customerObj.credit_limits" [(currencyCode)]="customerObj.credit_limits_currency"
                            [minValue]="0" [maxlength]="6" [maxValue]="max_credit_limit"
                            [errors]="errorObj.credit_limits">
                        </logzy-money-field>
                    </div>

                    <mat-slider fxFlex="100" fxFlex.gt-xs="13.8em" class="example-margin" [disabled]="!isEditable"
                        [max]="max_credit_limit" [min]="min_credit_limit" [step]="step" [thumbLabel]="thumbLabel"
                        [tickInterval]="getSliderTickInterval()" [(ngModel)]="customerObj.credit_limits"
                        [vertical]="vertical" aria-labelledby="credit_value">
                    </mat-slider>
                    <!-- </div> -->
                </div>
            </div>
            <ng-container *ngIf="!Loader">
                <div *ngIf="customerObj.virtual_account!=null" class="content form-group" id="" fxLayout="column wrap">
                    <div class="headContent" fxFlex="100">
                        <span class="head">
                            Virtual Account Details
                        </span>
                    </div>
                    <div fxFlex="100" class="inputs" fxLayout="row wrap">
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Virtual Account No</span>
                            </div>
                            <mat-form-field appearance="outline">
                                <input matInput type="text" name="depot_local_name" id="input3"
                                    (change)="changed($event)" value="">
                            </mat-form-field>
                        </div>
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Bank Name</span>
                            </div>
                            <mat-form-field appearance="outline">
                                <input matInput aria-label="State" [(ngModel)]="companyName" [matAutocomplete]="auto">
                                <mat-autocomplete #auto="matAutocomplete">
                                    <!-- <mat-option *ngFor="let option of filteredOptions | async" [value]="option.name">
                                        <span>{{option.name}}</span>
                                    </mat-option> -->
                                </mat-autocomplete>
                                <mat-icon matSuffix>search</mat-icon>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="content form-group" id="card6" fxLayout="column wrap" *ngIf="!Loader">
                <div class="headContent" fxFlex="100">
                    <span class="head">
                        Documents
                    </span>
                </div>
                <div class="doc_details" fxFlex="100" fxLayout="row wrap">
                    <app-file-field [isEditable]="isEditable" [fileDropArea]="true" [showUploadedList]="true"
                        [(ngModel)]="customerObj.documents" [documentTypeGroup]="'customer_doc_type'"
                        [name]="'documents'" [errors]="errorObj.document" fxFlex="100"
                        fxLayout="column"></app-file-field>
                </div>
            </div>
            <div class="content form-group" id="card7" fxLayout="column wrap" *ngIf="!Loader">
                <app-remarks fxLayout="row wrap" [isEditable]="isEditable" [forCustomerMaster]="true"
                    [placeholder]="'Enter your remark here.'" [(ngModel)]="customerObj.remarks"
                    [commentDate]="customerObj.updated_at" fxFlex="100" [updatedBy]="customerObj.updated_by"
                    [companyName]="customerObj.legal_name" [createdBy]="customerObj.created_by"
                    [createdAt]="customerObj.created_at"></app-remarks>

                <div class="btnb" fxFlex="100" fxLayout="row">
                    <button class="bck" mat-stroked-button cdkStepperPrevious>Back</button>
                    <button mat-stroked-button cdkStepperNext class="nxt"
                        (click)="isEditable ? patchCompanyDetails() : ''">
                        <ng-container *ngIf="customerObj.id">Update
                            and
                        </ng-container>
                        Next
                    </button>
                </div>
            </div>
        </div>
    </cdk-step>
    <cdk-step>
        <ng-template cdkStepLabel>Depot Commercials</ng-template>
        <div id="form3" class="form formLayout" action="">
            <ng-container *ngIf="showDoc">
                <logzy-content-loader *ngIf="Loader" [set2]="Loader"></logzy-content-loader>
                <div class="content form-group" id="card8" fxLayout="column wrap" *ngIf="!Loader">
                    <div class="headContent flexSpaceBtwn" fxFlex="100" fxLayout="row wrap">
                        <span class="head">
                            Bank Details
                        </span>
                        <button mat-raised-button (click)="openDD('Bank Details',null,true)" class="sleekBtn"
                            [class.clickIt]="pulse" [disabled]="!isEditable"><i class="flaticon-bank"></i> Add
                        </button>
                    </div>
                    <div fxFlex="100" class="inputs" fxLayout="row wrap">
                        <div fxFlex="100" class="cardContainer" fxLayout="row wrap">
                            <!-- <img id="cardBg" src="assets/images/icons/bank.svg" alt=""> -->

                            <div *ngFor="let bank of bankDetailsList?.results" class="distCard "
                                [class.main]="bank?.bank_type==1000" [class.intermediary]="bank?.bank_type==2000"
                                fxLayout="column wrap">
                                <div class="relative">
                                    <span>{{bank?.bank_type == 1000 ? 'Main Bank' : 'Intermediary Bank'}}</span>
                                </div>
                                <div class="topSec" fxFlex="3.28em">
                                    <div class="AccName">
                                        <span>{{bank?.account_name}}</span>
                                        <button mat-icon-button [disabled]="!isEditable" class="Save"
                                            (click)="openDD('Bank Details',bank,null)">
                                            <i class="flaticon-pencil" [class.noPointer]="!isEditable"></i>
                                        </button>
                                    </div>
                                    <div class="">
                                        <span class="fs-14 ">{{bank?.account_number}} ({{bank?.currency}})</span>
                                    </div>
                                </div>
                                <div class="hideSec">hide section</div>
                                <div class="bottomSec" fxFlex="3.28em" fxLayout="row">
                                    <div class="bankName">
                                        <span class="fs-14 ">{{bank?.bank_name}}</span>
                                        <span class="fs-12">{{bank?.branch_name_code}}</span>
                                    </div>
                                    <div class="">
                                        <span class="acc_type">{{bank?.account_type == 1000 ? 'Saving' :
                                            'Current'}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="w-100 " *ngIf="!(customerObj.id && bankDetailsList?.results.length)">
                                <span style="color: #999999; font-size: 12px;">No Bank details added.</span>
                            </div>
                            <!-- <div class="distCard intermediary" fxLayout="column wrap"
                                (mouseover)="pulsetoggler(isEditable)" (mouseout)="pulsetoggler(isEditable)"
                                *ngIf="!(customerObj.id && bankDetailsList?.results.length)">
                                <div class="relative">

                                    <span>Example Bank</span>
                                </div>
                                <div class="topSec" fxFlex="3.28em">
                                    <div class="AccName">
                                        <span> </span>
                                        <i class="flaticon-pencil"></i>
                                    </div>
                                    <div class="">
                                        <span class="fs-14 ">000000000000 (USD)</span>
                                    </div>
                                </div>
                                <div class="hideSec">hide section</div>
                                <div class="bottomSec" fxFlex="3.28em" fxLayout="row">
                                    <div class="bankName">
                                        <span class="fs-14 ">Bank of XXXXXX</span>
                                        <span class="fs-12"> Xxxxx xxxx xx xxxxx xxxx Xxxxxxx-000000</span>
                                    </div>
                                    <div class="">
                                        <span class="acc_type">Current</span>
                                    </div>
                                </div>
                            </div> -->

                        </div>
                    </div>
                </div>

                <div class="content form-group" id="card9" fxLayout="column wrap">
                    <div class="headContent flexSpaceBtwn" fxFlex="100" fxLayout="row wrap">
                        <span class="head">
                            Agreement Details
                        </span>
                        <!-- <button mat-raised-button (click)="addSignatory()"> <i class="flaticon-signature"></i>
                            Add</button> -->

                    </div>
                    <div class="op-charges" fxFlex="100" fxLayout="row wrap">
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Master Agreement No.*</span>
                            </div>
                            <app-text-field [isEditable]="isEditable" [name]="'agreement_no'"
                                [(ngModel)]="customerObj.master_agreement_no" [maxlength]="20"
                                [errors]="errorObj.agreement_no">
                            </app-text-field>
                        </div>
                        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Agreement Valid till</span>
                            </div>
                            <app-date-field [isEditable]="isEditable" [name]="'agreement_valid_till'"
                                [(ngModel)]="customerObj.master_agreement_valid_till"
                                [errors]="errorObj.agreement_valid_till"></app-date-field>
                        </div>

                        <div fxFlex="100" fxFlex.gt-xs="15.8em" fxLayout="column">
                            <div class="inputTitle">
                                <span>Document</span>
                            </div>
                            <app-file-field [isEditable]="isEditable" [fileDropArea]="false" [showUploadedList]="false"
                                [(ngModel)]="customerObj.master_agreement_document" [multiple]="false" [dotFloating]
                                [documentTypeGroup]="'request_document'" [name]="'master_agreement_document'"
                                [label]="'Upload Master agreement'" [isSolidUploadIcon]="true"
                                [errors]="errorObj.master_agreement_document"></app-file-field>
                            <span class="selectedCompanyLogo"
                                *ngIf="customerObj.master_agreement_document?.original_filename && isEditable">Selected:
                                <b>{{customerObj.master_agreement_document?.original_filename}}
                                    .{{customerObj.master_agreement_document?.extension}}</b></span>
                            <div *ngIf="!isEditable" class="agreementDoc">
                                <img *ngIf="customerObj.master_agreement_document?.extension"
                                    [src]="'/assets/images/icons/file-type/'+customerObj.master_agreement_document?.extension+'.svg'"
                                    alt="agreement_file">
                                <div fxLayout="column" class="align-items-flex-start">
                                    <a [href]='customerObj.master_agreement_document?.document_file' target="_blank"
                                        [download]="customerObj.master_agreement_document?.original_filename+'.'+customerObj.master_agreement_document?.extension">
                                        <span>{{customerObj.master_agreement_document?.original_filename}}
                                            .{{customerObj.master_agreement_document?.extension}}</span></a>
                                    <span>
                                        {{customerObj.master_agreement_document?.created_at|date:"dd MMM, yyyy"}}
                                    </span>
                                    <span>{{embassyService.readableFileSize(customerObj.master_agreement_document?.size)}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="btnb" fxFlex="100">
                            <button class="bck" mat-stroked-button cdkStepperPrevious>Back</button>
                            <button mat-stroked-button class="nxt" (click)="saveAgreementDetails()" *ngIf="customerObj.is_active"> Save</button>
                        </div>
                    </div>

                </div>

                <!-- <div class="content form-group" id="card10" fxLayout="column wrap">
                    <div class="headContent flexSpaceBtwn" fxFlex="100" fxLayout="row wrap">
                        <span class="head">
                            Signatory Details
                        </span>
                        <button mat-raised-button (click)="addSignatory()"> <i class="flaticon-signature"></i>
                            Add</button>

                    </div>
                    <div class="op-charges" fxFlex="100" fxLayout="row wrap">
                        <drag-table [todo1]="todo1"></drag-table>
                        <div class="btnb" fxFlex="100">
                            <button class="bck" mat-stroked-button cdkStepperPrevious>Back</button>
                            <button mat-stroked-button class="nxt" (click)="complete()"> Save</button>
                        </div>
                    </div>

                </div> -->

            </ng-container>
            <ng-container *ngIf="showCmplt">
                <div class="content form-group" id="card11" fxFlayout="column wrap">
                    <div class="bgImg" fxFlex="36.85em">
                        <img id="complete" src="assets/images/backgrounds/customerAdded.jpg" alt="">
                    </div>
                    <div class="cmpltTxt" fxFlex="100">
                        <div>
                            <span>Customer details saved successfully.</span>
                        </div>
                    </div>
                    <div class="btn dr-b-3em" fxFlex="100">

                        <button mat-stroked-button class="nxt" (click)="navigateToListPage()">
                            <div>
                                <i MatSuffix id="i1" class="flaticon-dashboard"></i>
                                <span>Go to Customer list page</span>
                            </div>
                        </button>
                        <button mat-stroked-button class="nxt" (click)="goToAddNewCustomer()">
                            <div>
                                <i MatSuffix id="i1" class="flaticon-customer"></i>
                                <span>Add a Customer</span>
                            </div>
                        </button>

                    </div>
                </div>
            </ng-container>
        </div>
    </cdk-step>
</cdk-customer-stepper>